module.exports = __webpack_public_path__ + "static/media/brand-icons.c5ebe0b3.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/brand-icons.ttf
// module id = 415
// module chunks = 0